import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { ROUTE_PATHS } from 'common/routePaths'

import NotFound from 'errorPages/NotFound'

import ChooseExpenseType from './chooseExpenseType'
import SubmitReimbursementRequest from './saveExpense'
import SubmitPremiumExpenseReimbursementRequest, {
  REQUEST_FOR_PREMIUM_EXPENSE_REIMBURSE_PATH,
} from './savePremiumExpense'

const SubmitReimbursementForm: React.FC = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_SUBMIT_EXPENSE} component={SubmitReimbursementRequest} exact />
      <Route
        path={`${match.path}/${REQUEST_FOR_PREMIUM_EXPENSE_REIMBURSE_PATH}`}
        component={SubmitPremiumExpenseReimbursementRequest}
        exact
      />
      <Route path={`${match.path}/:planPeriodId`} component={ChooseExpenseType} exact />
      <Route>
        <NotFound />
      </Route>
    </Switch>
  )
}

export default SubmitReimbursementForm
